export const loginEndPoint = 'https://medea.ai:4000/auth/login';
export const endPoint = 'https://medea.ai/api';
